angular.module('ihestiaCommonDirectives.strpos', []);